// 持有抽獎券 中獎紀錄
import { useDispatch } from 'react-redux';
import { setLoginModal, setCampaignRecordModal } from '@/slices/popSlice';

import Image from 'next/image';

const CampaignTickets = ({ user, ticketAmount }) => {
    const dispatch = useDispatch();

    // 查看中獎紀錄 需登入
    const onClickRecord = () => {
        if (user?.uid) dispatch(setCampaignRecordModal(true));
        else dispatch(setLoginModal(true));
    };

    return (
        <div
            className="flex items-center justify-between border-1 border-[#fff] border-opacity-[.22] rounded-[12px] px-[20px] py-[10px] mb-[22px]
        ulg:flex-col ulg:gap-y-[20px] ulg:p-[20px]"
        >
            <div className="flex items-center gap-x-[22px] ulg:gap-x-[10px]">
                <Image src="/images/campaign/icon_card.svg" width={28} height={28} alt="ticket" />

                {/* 持有抽獎券數 */}
                <p className="text-bd1m">抽獎券持有: {user?.uid ? ticketAmount : '登入後可查看'}</p>
            </div>

            <button
                onClick={onClickRecord}
                className="text-btn1 px-[22px] py-[16px] rounded-[8px] border-1 border-[#f7f7f8] border-opacity-[.2] bg-[#006F8B]
                trans hover:bg-[#00B5D3] ulg:w-full"
            >
                {user?.uid ? '我的中獎紀錄' : '登入查看中獎紀錄'}
            </button>
        </div>
    );
};

export default CampaignTickets;
